import axios from 'axios';
import authHeader from "@/service/auth-header";

class BillingPlanService {

    async getBillingPlans(companyId) {
        return await axios.get(`/api/billingplan/${companyId}`,{ headers: authHeader() })
    }

    async getCompanyBillingPlansForBookings(companyId) {
        return await axios.get(`/api/billingplan/bookings/${companyId}`,{ headers: authHeader() })
    }

    async getActiveBillingPlans(companyId) {
        return await axios.get(`/api/billingplan/active/${companyId}`,{ headers: authHeader() })
    }

    async searchBillingPlans(companyId, billingPlanName) {
        console.log("[BillingPlanService][searchBillingPlans] companyId = ", companyId);
        console.log("[BillingPlanService][searchBillingPlans] billingPlanName = ", billingPlanName);
        return await axios.get(`/api/billingplan/search/${companyId}/${billingPlanName}`,{ headers: authHeader() })
    }

    async getBillingPlan(billingPlanId) {
        return await axios.get(`/api/billingplan/specific/${billingPlanId}`,{ headers: authHeader() })
    }

    async createBillingPlan(companyId, data) {
        return await axios.post(`/api/billingplan/${companyId}`, data,{ headers: authHeader() });
    }

    async updateBillingPlan(billingPlanId, data) {
        return await axios.put(`/api/billingplan/${billingPlanId}`, data,{ headers: authHeader() });
    }

    async deleteBillingPlan(billingPlanId) {
        return await axios.delete(`/api/billingplan/${billingPlanId}`,{ headers: authHeader() })
    }

}

export default new BillingPlanService();
